// ============================================================================
// ITALIAN TRANSLATIONS - CHAPTER 7: LETTERE E APOCALISSE
// ============================================================================
// Livelli 79-91 (13 livelli, 39 domande)

export const chapter7Translations = {
  name: "Lettere e Apocalisse",
  description: "Chi vince erediterà tutte queste cose... La sapienza dall'alto santifica l'intelligenza",
  
  spiritualWisdom: {
    principle: "La sapienza dall'alto santifica l'intelligenza e vivifica lo spirito",
    scripture: "Se qualcuno di voi manca di sapienza, la chieda a Dio (Giacomo 1:5)",
    application: "Ogni lettera apostolica e ogni visione dell'Apocalisse arricchisce la nostra comprensione e rafforza la nostra speranza"
  },
  
  levels: {
    79: {
      name: "Arresto a Gerusalemme",
      challenge: "Sono pronto non solo a essere legato, ma anche a morire a Gerusalemme...",
      easy: {
        question: "Dove fu arrestato Paolo nell'ultima visita?",
        options: ["Antiochia", "Efeso", "Gerusalemme", "Corinto"],
        correctAnswer: 2,
        hint: "La città santa che spesso perseguitava i profeti",
        funFact: "🏛️ Gerusalemme: luogo di gloria e sofferenza per tutti i servitori di Dio!"
      },
      medium: {
        question: "Di cosa accusarono i Giudei Paolo?",
        options: [
          "Furto dal Tempio",
          "Profanazione del Tempio introducendo gentili",
          "Bestemmia contro Mosè",
          "Ribellione contro Roma"
        ],
        correctAnswer: 1,
        hint: "Accusa legata all'universalità del Vangelo",
        funFact: "⛪ Ironia: Paolo accusato di profanare il Tempio che onorava profondamente!"
      },
      hard: {
        question: "Come trasformò Paolo la sua prigionia in opportunità?",
        options: [
          "Fuggì",
          "Testimoniò davanti alle autorità e scrisse le sue epistole",
          "Tacque",
          "Negoziò la sua liberazione"
        ],
        correctAnswer: 1,
        hint: "Si tratta di trasformare la prova in testimonianza",
        funFact: "⛓️ Catene fisiche, libertà spirituale - potente testimonianza di fede!"
      }
    },
    
    80: {
      name: "Davanti al Governatore Felice",
      challenge: "Mentre dissertava sulla giustizia, l'autocontrollo e il giudizio futuro...",
      easy: {
        question: "Davanti a quale governatore Paolo testimoniò la sua fede?",
        options: ["Pilato", "Felice", "Festo", "Gallione"],
        correctAnswer: 1,
        hint: "Governatore noto per la sua avidità",
        funFact: "⚖️ Felice sperava in una tangente - corruzione di fronte all'integrità!"
      },
      medium: {
        question: "Qual fu la reazione di Felice al messaggio di Paolo?",
        options: [
          "Si convertì",
          "Tremò di paura",
          "Si beffò",
          "Rimase indifferente"
        ],
        correctAnswer: 1,
        hint: "La coscienza turbata dalla verità",
        funFact: "😰 Anche i corrotti tremano davanti alla verità divina - coscienza universale!"
      },
      hard: {
        question: "Perché Felice tenne Paolo prigioniero due anni?",
        options: [
          "Per proteggerlo",
          "Per interesse politico e speranza di corruzione",
          "Per dimenticanza",
          "Per convinzione"
        ],
        correctAnswer: 1,
        hint: "Si tratta di calcoli politici e personali",
        funFact: "🏛️ Giustizia umana corrotta vs giustizia divina perfetta - contrasto stridente!"
      }
    },

    81: {
      name: "Appello a Cesare",
      challenge: "Io mi appello a Cesare!",
      easy: {
        question: "Quale diritto invocò Paolo per evitare un processo a Gerusalemme?",
        options: [
          "Diritto d'asilo",
          "Appello a Cesare (cittadino romano)",
          "Diritto di fuga",
          "Protezione diplomatica"
        ],
        correctAnswer: 1,
        hint: "Privilegio della sua cittadinanza romana",
        funFact: "🏛️ Cittadinanza romana: passaporto divino per portare il Vangelo a Roma!"
      },
      medium: {
        question: "Davanti a chi testimoniò Paolo prima della partenza?",
        options: [
          "Il sinedrio",
          "Il re Agrippa e Berenice",
          "Soldati romani",
          "La folla giudaica"
        ],
        correctAnswer: 1,
        hint: "Regalità erodiana giudaizzata",
        funFact: "👑 Dal pastore di greggi al palazzo reale - elevazione divina di Paolo!"
      },
      hard: {
        question: "Come usa Dio i sistemi umani per i suoi piani?",
        options: [
          "Li ignora",
          "Li usa provvidenzialmente per realizzare i suoi disegni",
          "Li distrugge",
          "Si oppone sempre"
        ],
        correctAnswer: 1,
        hint: "Si tratta della sovranità divina sulla storia",
        funFact: "🌐 La giustizia romana diventa veicolo del Vangelo - provvidenza notevole!"
      }
    },

    82: {
      name: "Naufragio a Malta",
      challenge: "Non temere, Paolo; devi comparire davanti a Cesare...",
      easy: {
        question: "Su quale isola Paolo fece naufragio?",
        options: ["Creta", "Cipro", "Malta", "Sicilia"],
        correctAnswer: 2,
        hint: "Piccola isola a sud della Sicilia",
        funFact: "🏝️ Malta: sosta forzata diventa missione fruttuosa - deviazioni divine!"
      },
      medium: {
        question: "Quale miracolo compì Paolo a Malta?",
        options: [
          "Calmò la tempesta",
          "Guarì il padre di Publio e altri malati",
          "Moltiplicò il cibo",
          "Risuscitò un morto"
        ],
        correctAnswer: 1,
        hint: "Molteplici guarigioni sull'isola",
        funFact: "🏥 Paolo: da naufrago a medico miracoloso - reputazione divina!"
      },
      hard: {
        question: "Come illustra questo naufragio la fedeltà divina?",
        options: [
          "Gli incidenti capitano",
          "Dio protegge e adempie le sue promesse nonostante gli ostacoli",
          "Paolo fu fortunato",
          "Era evitabile"
        ],
        correctAnswer: 1,
        hint: "Si tratta della fedeltà divina alle promesse",
        funFact: "⛈️ Tempesta, naufragio, serpente: nulla ferma il piano divino per Paolo!"
      }
    },

    83: {
      name: "Paolo a Roma",
      challenge: "Rimase due anni interi in una casa che aveva preso in affitto...",
      easy: {
        question: "In quali condizioni visse Paolo a Roma?",
        options: [
          "In prigione chiusa",
          "Agli arresti domiciliari",
          "In libertà totale",
          "In esilio"
        ],
        correctAnswer: 1,
        hint: "Libertà relativa sotto sorveglianza",
        funFact: "🏠 Casa-prigione diventa centro missionario - libertà nelle catene!"
      },
      medium: {
        question: "Cosa fece Paolo durante i suoi due anni a Roma?",
        options: [
          "Si riposò",
          "Insegnò e scrisse le sue epistole",
          "Preparò la sua difesa",
          "Fece turismo"
        ],
        correctAnswer: 1,
        hint: "Ministero intenso nonostante le catene",
        funFact: "✍️ Epistole della prigionia: Efesini, Filippesi, Colossesi, Filemone!"
      },
      hard: {
        question: "Come terminò Paolo il suo ministero secondo la tradizione?",
        options: [
          "Morì di malattia",
          "Fu decapitato sotto Nerone verso il 67 d.C.",
          "Morì di vecchiaia",
          "Scomparve misteriosamente"
        ],
        correctAnswer: 1,
        hint: "Martirio sotto l'imperatore folle",
        funFact: "⚔️ 'Ho combattuto il buon combattimento, ho terminato la corsa' - vittoria finale!"
      }
    },

    84: {
      name: "L'Epistola ai Romani",
      challenge: "Non mi vergogno del Vangelo; esso è potenza di Dio per la salvezza...",
      easy: {
        question: "Quale epistola sviluppa di più la dottrina della salvezza per fede?",
        options: ["1 Corinzi", "Galati", "Romani", "Efesini"],
        correctAnswer: 2,
        hint: "La 'cattedrale' teologica di Paolo",
        funFact: "🏛️ Romani: capolavoro teologico che convertì Agostino e Lutero!"
      },
      medium: {
        question: "Secondo Romani, come è giustificato l'uomo davanti a Dio?",
        options: [
          "Per le sue buone opere",
          "Per fede soltanto, senza le opere",
          "Per i sacrifici",
          "Per la tradizione"
        ],
        correctAnswer: 1,
        hint: "Principio fondamentale della Riforma",
        funFact: "⚖️ 'Il giusto vivrà per fede' - rivoluzione spirituale di Paolo!"
      },
      hard: {
        question: "Qual è la portata universale di questa epistola?",
        options: [
          "Riguarda solo i Romani",
          "Espone il piano di salvezza per tutta l'umanità",
          "Critica solo Roma",
          "È obsoleta"
        ],
        correctAnswer: 1,
        hint: "Si tratta del piano universale di salvezza",
        funFact: "🌍 Vangelo = potenza di Dio per tutti: Giudei e Greci - universalità totale!"
      }
    },

    85: {
      name: "L'Inno all'Amore - 1 Corinzi 13",
      challenge: "Se parlassi le lingue degli uomini e degli angeli, ma non avessi amore...",
      easy: {
        question: "Quale capitolo della Bibbia è chiamato 'l'inno all'amore'?",
        options: [
          "1 Corinzi 12",
          "1 Corinzi 13",
          "1 Giovanni 4",
          "Romani 8"
        ],
        correctAnswer: 1,
        hint: "Il capitolo centrale di 1 Corinzi",
        funFact: "💝 Capitolo più letto ai matrimoni - definizione perfetta dell'amore!"
      },
      medium: {
        question: "Cosa dice Paolo sulla durata dell'amore?",
        options: [
          "L'amore passa col tempo",
          "L'amore non verrà mai meno",
          "L'amore dipende dalle circostanze",
          "L'amore è temporaneo"
        ],
        correctAnswer: 1,
        hint: "Eternità dell'amore divino",
        funFact: "♾️ Solo l'amore attraversa la morte e l'eternità - valore supremo!"
      },
      hard: {
        question: "Perché Paolo pone l'amore al di sopra dei doni spirituali?",
        options: [
          "I doni sono cattivi",
          "L'amore dà senso e valore a tutto il resto",
          "L'amore è più facile",
          "I doni dividono"
        ],
        correctAnswer: 1,
        hint: "Si tratta del motore e del senso di ogni servizio",
        funFact: "🎯 Senza amore, anche i doni più grandi diventano rumore e orgoglio!"
      }
    },

    86: {
      name: "Efesini: La Chiesa Corpo di Cristo",
      challenge: "Ogni cosa ha posto sotto i suoi piedi e lo ha dato per capo supremo alla Chiesa...",
      easy: {
        question: "Secondo Efesini, cos'è la Chiesa nella sua relazione con Cristo?",
        options: [
          "Il suo tempio",
          "Il suo corpo",
          "La sua famiglia",
          "Il suo esercito"
        ],
        correctAnswer: 1,
        hint: "Metafora organica di unità",
        funFact: "👤 Corpo di Cristo: ogni cristiano è un membro vitale - interdipendenza!"
      },
      medium: {
        question: "Quale armatura descrive Paolo per il combattimento spirituale?",
        options: [
          "Armatura fisica",
          "Armatura di Dio: verità, giustizia, pace, fede, salvezza, Parola",
          "Armatura romana",
          "Protezione magica"
        ],
        correctAnswer: 1,
        hint: "Sei pezzi di armatura spirituale",
        funFact: "⚔️ Combattimento spirituale con armi spirituali - strategia divina di vittoria!"
      },
      hard: {
        question: "Contro chi è la nostra vera lotta secondo Paolo?",
        options: [
          "Contro uomini malvagi",
          "Contro le potenze spirituali della malvagità",
          "Contro i governi",
          "Contro la povertà"
        ],
        correctAnswer: 1,
        hint: "Si tratta di forze spirituali invisibili",
        funFact: "👹 Combattimento cosmico: dietro i conflitti umani, guerra spirituale reale!"
      }
    },

    87: {
      name: "Filippesi: La Gioia nella Prova",
      challenge: "Rallegratevi sempre nel Signore; ripeto: rallegratevi!",
      easy: {
        question: "Quale sentimento Paolo incoraggia nonostante la sua prigionia?",
        options: ["La rassegnazione", "La gioia", "La rabbia", "La tristezza"],
        correctAnswer: 1,
        hint: "Emozione sorprendente per un prigioniero",
        funFact: "😊 Gioia 16 volte in 4 capitoli - record di felicità in prigione!"
      },
      medium: {
        question: "Secondo Filippesi 2, quale atteggiamento adottò Gesù?",
        options: [
          "Si impose con la forza",
          "Si abbassò e umiliò fino alla morte",
          "Fuggì dalle sue responsabilità",
          "Cercò la gloria"
        ],
        correctAnswer: 1,
        hint: "Movimento discendente volontario",
        funFact: "📉 Gesù: dall'uguaglianza con Dio alla morte in croce - amore estremo!"
      },
      hard: {
        question: "Come può Paolo predicare la gioia in prigione?",
        options: [
          "Sta fingendo",
          "La gioia cristiana trascende le circostanze",
          "È masochista",
          "Nega la realtà"
        ],
        correctAnswer: 1,
        hint: "Si tratta di una gioia soprannaturale",
        funFact: "✨ Gioia = frutto dello Spirito indipendente dalle circostanze - segreto divino!"
      }
    },

    88: {
      name: "Le Epistole Pastorali",
      challenge: "Combatti il buon combattimento della fede, afferra la vita eterna...",
      easy: {
        question: "A chi Paolo scrisse le sue ultime lettere pastorali?",
        options: [
          "Ai Corinzi",
          "A Timoteo e Tito",
          "Ai Romani",
          "Ai Galati"
        ],
        correctAnswer: 1,
        hint: "I suoi figli spirituali e collaboratori",
        funFact: "👨‍👦 Testamento spirituale: Paolo passa la fiaccola alla generazione successiva!"
      },
      medium: {
        question: "Quale consiglio dà Paolo per scegliere i leader della chiesa?",
        options: [
          "Scegliere i più ricchi",
          "Scegliere secondo criteri morali e spirituali rigorosi",
          "Scegliere i più istruiti",
          "Scegliere i più popolari"
        ],
        correctAnswer: 1,
        hint: "Qualificazioni morali prima di tutto",
        funFact: "⚖️ Standard elevati per i leader: carattere prima della competenza - priorità divine!"
      },
      hard: {
        question: "Quale eredità lascia Paolo a Timoteo?",
        options: [
          "Beni materiali",
          "La fedeltà al Vangelo e il ministero pastorale",
          "Una funzione politica",
          "Una scuola teologica"
        ],
        correctAnswer: 1,
        hint: "Si tratta di eredità spirituale",
        funFact: "📜 'Custodisci il buon deposito' - trasmissione fedele del Vangelo attraverso i secoli!"
      }
    },

    89: {
      name: "Ebrei: Gesù Sommo Sacerdote",
      challenge: "Abbiamo un grande sommo sacerdote che ha attraversato i cieli...",
      easy: {
        question: "Secondo Ebrei, chi è il nostro grande sommo sacerdote?",
        options: ["Aronne", "Mosè", "Gesù", "Melchisedec"],
        correctAnswer: 2,
        hint: "Il mediatore perfetto tra Dio e gli uomini",
        funFact: "✝️ Gesù: Sacerdote e Vittima - sacrificio perfetto una volta per sempre!"
      },
      medium: {
        question: "Perché il sacerdozio di Gesù è superiore a quello di Aronne?",
        options: [
          "È più antico",
          "È eterno secondo l'ordine di Melchisedec",
          "È più ricco",
          "È più popolare"
        ],
        correctAnswer: 1,
        hint: "Eternità vs temporalità",
        funFact: "♾️ Sacerdozio eterno: Gesù intercede perpetuamente per noi!"
      },
      hard: {
        question: "Come presenta Ebrei la Nuova Alleanza?",
        options: [
          "Identica all'antica",
          "Superiore e definitiva, scritta nei cuori",
          "Temporanea",
          "Opzionale"
        ],
        correctAnswer: 1,
        hint: "Si tratta di compimento e superamento",
        funFact: "📋 Nuova Alleanza: legge scritta nei cuori, non sulla pietra!"
      }
    },

    90: {
      name: "Giacomo: La Fede e le Opere",
      challenge: "La fede senza le opere è morta...",
      easy: {
        question: "Secondo Giacomo, cosa deve accompagnare la fede?",
        options: [
          "Le parole",
          "Le opere",
          "Le emozioni",
          "La conoscenza"
        ],
        correctAnswer: 1,
        hint: "Manifestazione pratica della fede",
        funFact: "🌳 Fede = radice, opere = frutti - albero spirituale completo!"
      },
      medium: {
        question: "A cosa paragona Giacomo la lingua?",
        options: [
          "A una spada",
          "A un piccolo fuoco che incendia una grande foresta",
          "A uno strumento musicale",
          "A un utensile"
        ],
        correctAnswer: 1,
        hint: "Piccolo membro ma grande potere distruttivo",
        funFact: "🔥 Lingua: piccolo membro ma può incendiare un'intera vita - prudenza!"
      },
      hard: {
        question: "Come conciliare Giacomo e Paolo su fede/opere?",
        options: [
          "Si contraddicono",
          "Paolo parla di giustificazione, Giacomo di santificazione",
          "Uno ha torto",
          "Non c'è soluzione"
        ],
        correctAnswer: 1,
        hint: "Si tratta di due aspetti complementari",
        funFact: "⚖️ Paolo: salvati per fede / Giacomo: fede provata dalle opere - armonia perfetta!"
      }
    },

    91: {
      name: "Apocalisse: Il Ritorno del Re",
      challenge: "Ecco, vengo presto. Beato chi custodisce le parole della profezia di questo libro!",
      easy: {
        question: "A quante chiese scrive Giovanni nell'Apocalisse?",
        options: ["5", "7", "10", "12"],
        correctAnswer: 1,
        hint: "Il numero della perfezione",
        funFact: "⛪ 7 chiese d'Asia: specchio di tutte le chiese di tutti i tempi!"
      },
      medium: {
        question: "Come finisce la storia secondo l'Apocalisse?",
        options: [
          "Distruzione totale",
          "Cieli nuovi e terra nuova",
          "Ritorno al paradiso terrestre",
          "Fine di ogni esistenza"
        ],
        correctAnswer: 1,
        hint: "Rinnovamento completo della creazione",
        funFact: "🌅 Non fine del mondo ma rinnovamento totale - speranza ultima!"
      },
      hard: {
        question: "Quale messaggio centrale trasmette l'Apocalisse ai perseguitati?",
        options: [
          "Arrendetevi",
          "Cristo regna e trionferà definitivamente",
          "Fuggite dalla persecuzione",
          "Vendicatevi"
        ],
        correctAnswer: 1,
        hint: "Si tratta di speranza nella vittoria finale",
        funFact: "👑 'Colui che era, che è e che viene' - Signore della storia e del tempo!"
      }
    }
  }
};

export default chapter7Translations;
